export const toCurrency = (rawPrice: number | undefined): string => {
  return rawPrice ? `Rp${rawPrice.toLocaleString('ID')}` : ''
}
